import { z } from 'zod';

/**
 * Payment Processing Schemas
 * Payment methods, intents, errors, and refunds
 */

// Payment Method Type Enum
export const PaymentMethodTypeSchema = z.enum(['card', 'bank_account', 'digital_wallet'], {
  error: "Invalid payment method type"
});

// Payment Intent Status Enum
export const PaymentIntentStatusSchema = z.enum([
  'requires_payment_method',
  'requires_confirmation', 
  'requires_action',
  'processing',
  'requires_capture',
  'canceled',
  'succeeded'
], {
  error: "Invalid payment intent status"
});

// Payment Subscription Status Enum (includes Stripe-specific statuses)
export const PaymentSubscriptionStatusSchema = z.enum([
  'ACTIVE', 'CANCELED', 'PAST_DUE', 'UNPAID', 'INCOMPLETE',
  'INCOMPLETE_EXPIRED', 'TRIALING', 'PAUSED'
], {
  error: "Invalid payment subscription status"
});

// Payment Error Type Enum (standardized across payment providers)
export const PaymentErrorTypeSchema = z.enum([
  'card_error',
  'invalid_request_error', 
  'api_error',
  'authentication_error',
  'rate_limit_error'
], {
  error: "Invalid payment error type"
});

// Refund Status Enum
export const RefundStatusSchema = z.enum([
  'pending',
  'succeeded', 
  'failed',
  'canceled'
], {
  error: "Invalid refund status"
});

// Refund Reason Enum
export const RefundReasonSchema = z.enum([
  'duplicate',
  'fraudulent',
  'requested_by_customer'
], {
  error: "Invalid refund reason"
});

// Export TypeScript types
export type PaymentMethodType = z.infer<typeof PaymentMethodTypeSchema>;
export type PaymentIntentStatus = z.infer<typeof PaymentIntentStatusSchema>;
export type PaymentSubscriptionStatus = z.infer<typeof PaymentSubscriptionStatusSchema>;
export type PaymentErrorType = z.infer<typeof PaymentErrorTypeSchema>;
export type RefundStatus = z.infer<typeof RefundStatusSchema>;
export type RefundReason = z.infer<typeof RefundReasonSchema>;